const myTime = function () {
  var time = new Date()
  var offset = time.getTimezoneOffset()
  var stampGTM = time.getTime() + offset * 60 * 1000
  return new Date(stampGTM + (1000 * 60 * 60 * 8))
}
export default myTime
